<template>
  <div>
    <v-container container--fluid>
      <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
        <v-col md="3" cols="12">
          <v-text-field label="Search..." v-model="search" v-on:keyup.enter="getInvoices" prepend-icon="search"></v-text-field>
        </v-col>
        <v-col md="1" cols="12">
          <h4 style="text-align: center">From Date</h4>
        </v-col>
        <v-col md="2" cols="12">
          <v-dialog
            ref="dialogFrom"
            v-model="modalFrom"
            :return-value.sync="fromDate"
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fromDate"
              scrollable :max="today"
            >
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-1" @click="modalFrom = false">Cancel</v-btn>
              <v-btn text color="blue darken-1" @click="$refs.dialogFrom.save(fromDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col md="1" cols="12">
          <h4 style="text-align: center">To Date</h4>
        </v-col>
        <v-col md="2" cols="12">
          <v-dialog
            ref="dialogTo"
            v-model="modalTo"
            :return-value.sync="toDate"
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="toDate"
              scrollable :min="fromDate" :max="today"
            >
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-1" @click="modalTo = false">Cancel</v-btn>
              <v-btn text color="blue darken-1" @click="$refs.dialogTo.save(toDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col md="1" cols="12" style="text-align: center">
          <v-btn text outlined color="blue darken-1" @click="this.reload = !this.reload;">Search</v-btn>
        </v-col>

        <v-col md="1" cols="12" style="text-align: center" v-if="editPermission">
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn icon color="indigo" @click="newContractorInvoice" v-on="on">
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>Create a new invoice</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-alert type="warning" :value="searchAlert">
        Please make sure you specified a date range
      </v-alert>

    </v-container>

    <v-divider></v-divider>

    <v-data-table
      :headers="headers"
      :searching="searching"
      :sort-by="'date'"
      :items="renderedInvoices"
      :search="search"
      ref="table"
    >
      <template v-slot:item.actions="props">
        <v-tooltip top color="secondary" v-if="props.item.attachment != null">
          <template v-slot:activator="{ on }">
            <v-icon color="blue" @click="invoiceExport(props.item)" v-on="on">
              cloud_download
            </v-icon>
          </template>
          <span>Download Attachment</span>
        </v-tooltip>
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-icon medium :color="props.item.approved ? 'grey' : 'green'" @click="approve(props.item)" v-on="on">
              mdi-check
            </v-icon>
          </template>
          <span>{{ props.item.approved ? 'Approved' : 'Approve' }}</span>
        </v-tooltip>
        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on }">
            <v-icon medium color="blue" @click="displayPdfInvoice(props.item)" v-on="on">
              mdi-eye
            </v-icon>
          </template>
          <span>View</span>
        </v-tooltip>
        <v-tooltip top color="secondary" v-if="editPermission">
          <template v-slot:activator="{ on }">
            <v-icon medium color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
              delete
            </v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ATTENTION
        </v-card-title>
        <v-card-text>
          You are about to delete this invoice. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="red">No</v-btn>
          <v-btn outline @click="deleteInvoice" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="alertDialog"
      max-width="500px">
      <v-card>
        <v-card-title>
          ALERT
        </v-card-title>
        <v-card-text>
          {{message}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue darken-1" @click="alertDialog=false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CreateContractorInvoice
      :createContractorInvoiceDialog="createContractorInvoiceDialog"
      :contractor="contractor"
      ref="editComponent"
      :editedIndex="editedIndex"
      :invoiceId="invoiceId"
      :defaultInvoice="defaultInvoice"
      v-on:updateDataTableParent="updateDataTable()"
      @close="closeContractorInvoiceDialog"
    ></CreateContractorInvoice>
  </div>
</template>

<script>
    import axios from 'axios';
    import CreateContractorInvoice from './CreateContractorInvoice';
    export default {
        name: "ContractorInvoiceDataTable",
        props: {
            contractor: Object,
        },
        components: {
            CreateContractorInvoice,
        },
        data() {
            return {
                invoiceId: -1,
                invoice: null,
                search:'', // input search
                searching: false, //input for dates
                loading: false,
                reload: false,
                modalFrom: false,
                modalTo: false,
                fromDate: null,
                toDate: null,
                today: new Date().toISOString().substr(0, 10),
                alertDialog: false,
                message: '',
                createContractorInvoiceDialog: false,
                editedIndex: -1,
                searchAlert: false,
                toBeDeleted: null,
                deleteDialog: false,
                defaultInvoice: {
                    invoice_number: '',
                    date: null,
                    due: null,
                    fromDate: null,
                    toDate: null,
                    adjustment: 0,
                    attachment: null,
                    routes: []
                },
                editedInvoice: {
                    invoice_number: '',
                    date: null,
                    due: null,
                    adjustment: 0,
                    attachment: null,
                    routes: []
                },
              headers: [
                {text: 'Id', value: 'id', align: 'center', sortable: true},
                {text: 'Invoice Number', value: 'invoice_number', align: 'center', sortable: true},
                {text: 'Date', value: 'date', align: 'center', sortable: true},
                {text: 'Total Cost ($)', value: 'total', align: 'center', sortable: true},
                {text: 'Actions', value: 'actions', align: 'right', sortable: false}
              ],
                fields: {
                  invoice_number: 'Invoice Number',
                  date: 'Invoice Date',
                  total: 'Due Date',
                },
                invoiceAddRoutesDialog:false,
            }
        },
        computed: {
          renderedInvoices() {
              if (this.getInvoices === null || this.getInvoices === undefined) return [];
              return this.getInvoices;
          },
          editPermission() {
            return this.$store.getters['auth/hasPermissionRegionId']('contractors_edit_invoices', this.contractor.region_id);
          },
          approvePermission() {
            return this.$store.getters['auth/hasPermissionRegionId']('contractors_approve_invoices', this.contractor.region_id);
          }
        },
        asyncComputed: {
            async getInvoices() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    this.searching = true;
                    this.searchAlert = false;
                    if (this.fromDate === null || this.fromDate === undefined || this.toDate === null || this.toDate === undefined) {
                        this.searchAlert = true;
                        return null;
                    } else {
                        return await axios.get(process.env.API_URL + '/contractors/' + this.contractor.id + '/invoices')
                            .then((response) => {
                                if (response.status === 200) {
                                    this.loading = false;
                                    return response.data;
                                } else {
                                    this.loading = false;
                                    this.searching = false;
                                    this.message = 'ERROR ' + response.status + 'while getting the Invoices data.';
                                    return [];
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                this.displayMessage('ERROR ' + error.response.status + 'while getting the Invoices data.');
                                this.searching = false;
                                return [];
                            });
                    }
                }
            }
        },
        methods: {
            newContractorInvoice() {
                this.editedIndex = -1;
                this.invoiceId = -1;
                this.createContractorInvoiceDialog = true;
            },
            closeContractorInvoiceDialog() {
                this.createContractorInvoiceDialog = false;
                setTimeout(() => {
                    this.editedInvoice = Object.assign({}, this.defaultInvoice);
                    this.editedIndex = -1;
                }, 300)
                this.updateDataTable();
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            deleteInvoice() {
                axios.delete(process.env.API_URL + '/contractors/' + this.contractor.id  + '/invoices/' +  this.toBeDeleted.id)
                    .then((response) => {
                        this.toBeDeleted = null;
                        this.deleteDialog = false;
                        this. updateDataTable();
                        this.$store.commit('displaySnackbar', 'Delete successful');
                    })
                    .catch ((error) => {
                        this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
                    });
                // this.getInvoicesFromDates()
                this.updateDataTable();
            },
            viewRow(item) {
                this.invoiceId = item.id;
                this.editedIndex = this.getInvoices.indexOf(item)
                this.createContractorInvoiceDialog = true;
            },
            updateDataTable() {
                this.reload = !this.reload;
            },
            invoiceExport(item) {
              window.open(item['attachment'], '_blank');
            },

            toggleExpand(row) {
              if (this.expanded.findIndex(x => x.id === row.id) === -1) {
                this.expanded.push(row);
              } else {
                this.expanded = this.expanded.filter(x => x.id !== row.id);
              }
            },
            formatPrice(value) {
              let val = (value / 1).toFixed(2).replace('.', ',');
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            displayPdfInvoice(item) {
              window.open(process.env.API_URL +'/contractors/'+ this.contractor.id + '/invoices/' + item.id + '/pdf' + '?key=' + encodeURI(this.$store.state.auth.key), '_blank');
            },
            approve(item) {
              if (!item.approved) {
                axios.post(process.env.API_URL + '/contractors/' + this.contractor.id  + '/invoices/' +  item.id + '/approve')
                  .then((response) => {
                    this. updateDataTable();
                    this.$store.commit('displaySnackbar', 'Invoice approved!');
                  })
                  .catch ((error) => {
                    this.$store.commit('displaySnackbar', 'ERROR: ' + (error.response.data ? error.response.data.error : 'Unknown error'));
                  });
              }
            },
            invoiceSelected(item){
                // to do
            }

        },
        mounted: function () {
            let d = new Date();
            d.setDate((new Date()).getDate() - 14);
            let DateInvoiceMinusTwoWeek = d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
            this.fromDate = DateInvoiceMinusTwoWeek;
            let e = new Date();
            e.setDate((new Date()).getDate() + 7);
            let DateInvoicePlusOneWeek = e.getFullYear() + '-' + (e.getMonth()+1) + '-' + e.getDate();
            this.toDate = DateInvoicePlusOneWeek;
            // this.getInvoicesFromDates();
            this.updateDataTable();
        }

    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/util/Contractors/ContractorInvoiceDataTable.vue